import { IMAGES } from "@/lib/site";

const POINTS = [
  "Direct cell access to licensed PE, PS, and RLS throughout the project",
  "Fast turnaround on Central Ohio municipal boundary & site revisions",
  "Elimination of billable administrative overhead"
];

export const Practice = () => (
  <section id="practice" className="py-24 bg-white border-b border-stone-200" data-testid="practice-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-stone-400 flex flex-col justify-end shadow-md relative">
            <img
              src={IMAGES.practice}
              alt="Open field at golden hour — Central Ohio land ready for survey and development"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
              data-testid="practice-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-transparent"></div>
            <div className="relative z-10 text-white p-8">
              <span className="text-xs uppercase font-bold text-amber-400 tracking-wider">Direct Accountability</span>
              <h3 className="text-xl font-bold mt-1">The Same Engineer in the Mud and on the Stamp</h3>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <h2 className="text-xs font-bold uppercase tracking-widest text-amber-800 mb-2">Boutique Firm Advantage</h2>
          <p className="font-display text-3xl font-bold text-stone-950 mb-6">No Mid-Tier Hand-Offs. No Translation Errors.</p>
          <p className="text-stone-700 leading-relaxed mb-6">
            In traditional multi-tier civil consultancies, your project passes from sales partner to project manager to junior draftsman. Diamond V operates on direct principal immersion: Steve Lamphear leads field monument recovery, processes GNSS vectors, drafts the Civil 3D alignments, and seals the final submittal.
          </p>
          <div className="space-y-3 text-sm text-stone-800 font-medium">
            {POINTS.map((point) => (
              <div key={point} className="flex items-center gap-3">
                <span className="w-2 h-2 rounded-full bg-amber-700"></span>
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
